import { SET_START_ROOM_TOUR } from '../actions/onboarding-actions-types'

const INITIAL_STATE_SET_START_ROOM_TOUR = { results: '' }

export function setStartRoomTourReducer(state = INITIAL_STATE_SET_START_ROOM_TOUR, action) {
    switch (action.type) {
        case SET_START_ROOM_TOUR:
            return { results: action.payload }
        default:
            return state;
    }
}